<template>
  <div class="reporting__frequency" :style="{marginTop: reportPeriod.start === reportPeriod.end && '10px', height: !freqData ? '444px' : '', touchAction: isMobile && dragging ? 'pan-y' : 'auto'}" ref="frequencyRef">
    <i v-if="reportPeriod.start === reportPeriod.end"
       class="icon icon-binding">
    </i>
    <ui-loading-circle v-if="isLoading" :applyBackground="true"/>
    <template v-if="freqData && !isLoading">
      <div class="frequency_wrapper">
        <div class="frequency_text_wrap">
          <div class="frequency_header">
            <span class="frequency_title">
  <!--            <i class="icon icon&#45;&#45;beta-small"></i>-->
              {{ $t('reporting.frequency.title') }}
            </span>
            <div class="option-wrap">
              <span class="option" :class="option" @click="selectedOption">{{ $t('common.session')}}</span>
              <span class="option" :class="option" @click="selectedOption">PV</span>
            </div>
          </div>
          <div class="frequency_average">
            <span class="text">{{ mean }}</span>
            <span class="checkbox_wrap" :class="{on: isRange}" @click="onRangeCheck">
                <i class="icon icon--chkbox"></i>
                <span class="text">{{ $t('reporting.frequency.range') }}</span>
            </span>
          </div>
        </div>
        <div class="frequency_graph_container">
          <div class="frequency_guide">
            <div>
              {{ $t('reporting.frequency.visits') }} <br>
              ({{ option === 'pv' ? 'PV' : $t('common.session') }})
              <!-- {{ option === 'pv'
                  ? $t('reporting.frequency.visitsPv')
                  : $t('reporting.frequency.visitsSession')
              }} -->
            </div>
            <div>
              {{ $t('reporting.frequency.uv') }}
            </div>
          </div>
          <div class="frequency_graph_wrap">
            <div class="graph_y">
              <div v-for="(item, index) in freqData" class="text_wrap" :class="{big: bigFanIndex === index}" :key="index">
                <span class="text_y" :class="{maxVisits: index === 0}">
                  {{ item.pv === 'over' ? option === 'session' ? '31+' : '51+' : item.pv }}
                  <template v-if="item.pv === 'over'" class="max">
                    (max)
                  </template>
                </span>
                <span class="big-fan" v-if="bigFanIndex === index">
                  <i class="icon icon--big-fan-check"></i>
                </span>
              </div>
            </div>
            <div class="graph"
                 ref="graph"
                 @mouseover="isHover = true"
                 @mouseleave="isHover = false">
              <div class="bg-container" v-if="isMobile" @touchstart="startDrag" ref="rangeRef">
                <div class="select-bg"
                     v-if="rangeTopPosition"
                     :style="{height: `${selectHeight}px`, top: rangeTopPosition, bottom: rangeBottomPosition}"
                     :class="{rangeSelect: isRangeSelect && isRange, select: isClicked && !isRange}"
                     ref="selectRef"
                     @click="sameSelect()">
                  <span class="dot-line" v-if="isRangeSelect && isRange"></span>
                </div>
                <div class="bg-wrap"
                     :class="{range: isRange}"
                     :style="index === 0 && 'border-top-left-radius: 6px; border-top-right-radius: 6px;'"
                     v-for="(item, index) in freqData" :key="index" @click="onSelectClick($event, item, index)"
                     @mouseover="uvOverHandler(index)"
                     @mouseleave="uvLeaveHandler(index)"
                >
                </div>
              </div>
              <div class="bg-container" v-else @mousedown="startDrag" ref="rangeRef">
                <div class="select-bg"
                     v-if="rangeTopPosition"
                     :style="{height: `${selectHeight}px`, top: rangeTopPosition, bottom: rangeBottomPosition}"
                     :class="{rangeSelect: isRangeSelect && isRange, select: isClicked && !isRange}"
                     ref="selectRef"
                     @click="sameSelect()"
                     @mouseenter="selectedHover = true"
                     @mouseleave="selectedHover = false">
                  <span class="dot-line" v-if="isRangeSelect && isRange"></span>
                </div>
                <div class="bg-wrap"
                     :class="{range: isRange, big: bigFanIndex === index}"
                     :style="index === 0 && 'border-top-left-radius: 6px; border-top-right-radius: 6px;'"
                     v-for="(item, index) in freqData" :key="index" @click="onSelectClick($event, item, index)"
                     @mouseover="uvOverHandler(index)"
                     @mouseleave="uvLeaveHandler(index)"
                    >
                </div>
              </div>
              <svg v-if="freqData" id="frequency_graph" :class="{notHover: !isHover}" :width="graphWidth" height="240" xmlns="http://www.w3.org/2000/svg" ref="svgGraph">
              </svg>
              <ui-tooltip v-if="bigFanIndex && uvHoverIndex === null && !isHover"
                          arrow-bottom
                          arrow-center
                          class="insight"
                          :style="{top: maxCircleY}">
                {{ $t(`reporting.frequency.insight.${bigFanIndex}`)}}
              </ui-tooltip>
            </div>
          </div>
        </div>
      </div>
      <div class="frequency_big_fan_container">
        <p class="big-fan-zone">
          <i class="icon icon--big-fan-check"></i>
          Big Fan Zone
        </p>
        <span class="big-fan-desc" :class="$i18n.locale" v-html="$t('reporting.frequency.bigFan')">
        </span>
      </div>
      </template>
      <!--  no-data  -->
      <div class="none-pv-container" v-else>
        <div class="frequency_header">
          <span class="frequency_title">{{ $t('reporting.frequency.title') }}</span>
          <div class="option-wrap">
            <span class="option" :class="option" @click="selectedOption">Session</span>
            <span class="option" :class="option" @click="selectedOption">PV</span>
          </div>
        </div>
        <div class="none-pv-text" v-if="!isLoading">
          <span v-if="option === 'session'">
            {{ $t('reporting.timeSeries.noSessionByDate') }}
          </span>
          <span v-else>
            {{ $t('reporting.timeSeries.noPvByDate') }}
          </span>
        </div>
      </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import { getFreqInfoData } from '@/api/report'
import { thousand } from '@/libs/utils'
import { FREQUENCY_HEIGHT, FREQUENCY_PV_RANGE, FREQUENCY_SESSION_RANGE } from '@/libs/constants'
import UiIconTooltip from '@/components/ui/UiIconTooltip.vue'
import ClickAnimation from '@/components/common/ClickAnimation.vue'
import UiTooltip from '@/components/ui/UiTooltip.vue'
import UiLoadingCircle from '@/components/ui/UiLoadingCircle.vue'

export default {
  name: 'ReportFrequency',
  components: {
    UiLoadingCircle,
    UiTooltip,
    ClickAnimation,
    UiIconTooltip
  },
  props: {
    apiParamsData: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      isRange: false,
      isClicked: false,
      isHover: false,
      canvasWidth: null,
      selectHeight: FREQUENCY_HEIGHT,
      startY: 0,
      dragging: false,
      isRangeSelect: false,
      rangeTopPosition: null,
      rangeBottomPosition: null,
      baseY: null,
      rangeStartIdx: null,
      rangeEndIdx: null,
      maxCircleX: null,
      maxCircleY: null,
      hoverState: {},
      isMobile: /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent),
      mobileY: null,
      graphWidth: null,
      freqData: null,
      freqMeanData: null,
      freqTotalPv: null,
      isLoading: false,
      option: 'session',
      uvHoverIndex: null,
      selectedIndex: null,
      selectedHover: false,
      weightList: [6, 5, 4, 3, 2, 1]
    }
  },
  watch: {
    isRange () {
      if (!this.freqData) return
      this.$store.commit('clearFreqSelect')
      this.drawLineGraph()
    },
    startY () {
      this.selectHeight = FREQUENCY_HEIGHT
    },
    timeseriesData () {
      this.drawLineGraph()
    },
    isLoading (value) {
      if (value) {
        this.$emit('onHeatmapLoadStart')
      } else {
        this.$emit('onHeatmapLoadEnd')
      }
    },
    option (value, oldValue) {
      if (value !== oldValue) {
        this.$emit('onFreqOption', null)
      }
    }
  },
  computed: {
    ...mapState([
      'userData',
      'reportPeriod',
      'timeseriesData',
      'freqRangeSelect',
      'freqSelect',
      'freqRange'
    ]),
    mean () {
      const numStr = this.freqMeanData.toString()
      const decimalIndex = numStr.indexOf('.')
      if (decimalIndex !== -1 && numStr[decimalIndex + 1] === '0') {
        return this.$t('reporting.frequency.mean', {
          mean: this.freqMeanData.split('.')[0]
        })
      }
      return this.$t('reporting.frequency.mean', {
        mean: this.freqMeanData
      })
    },
    bigFanIndex () {
      const list = []
      for (let i = 0; i < this.freqData.length; i++) {
        list.push(this.freqData[i].totalPv * this.weightList[i])
      }
      return list.indexOf(Math.max(...list))
    }
  },
  created () {
    this.loadFreqData(this.option)
  },
  mounted () {
    this.isRange = this.freqRangeSelect.isRange ? this.freqRangeSelect.isRange : this.freqRange
    this.selectHeight = this.freqRangeSelect.selectHeight ? this.freqRangeSelect.selectHeight : this.freqSelect.selectHeight
    this.rangeTopPosition = this.freqRangeSelect.rangeTopPosition ? this.freqRangeSelect.rangeTopPosition : this.freqSelect.rangeTopPosition
    this.rangeBottomPosition = this.freqRangeSelect.rangeBottomPosition
    this.rangeStartIdx = this.freqRangeSelect.rangeStartIdx
    this.isRangeSelect = this.freqRangeSelect.isRangeSelect
    this.isClicked = this.freqSelect.isClicked
  },
  methods: {
    ...mapMutations([
      'setFreqRangeSelect',
      'setFreqSelect',
      'setFreqRange'
    ]),
    loadFreqData (option = null) {
      this.isLoading = true
      const params = { ...this.apiParamsData }
      params.freq_option = option
      getFreqInfoData(params).then(result => {
        if (result.data !== undefined && result.data.length !== 0) {
          this.freqData = result.data.slice().reverse()
          this.freqMeanData = result.mean.toFixed(1)
          this.$emit('onFreqData', this.freqData, this.freqMeanData)
          this.$nextTick(() => {
            this.drawLineGraph()
            window.addEventListener('resize', () => {
              this.drawLineGraph()
            })
          })
          this.isLoading = false
        } else {
          this.freqData = null
          this.freqMeanData = null
          this.$emit('onFreqData', this.freqData, this.freqMeanData)
          this.isLoading = false
        }
      }).catch(err => {
        this.isLoading = false
        console.error(err)
      })
    },
    drawLineGraph () {
      const ns = 'http://www.w3.org/2000/svg'
      const svg = this.$refs.svgGraph
      this.graphWidth = this.$el.querySelector('.graph').clientWidth

      if (!svg) {
        return
      }

      // 이전에 그려진 SVG가 있다면 제거합니다.
      while (svg.firstChild) {
        svg.removeChild(svg.firstChild)
      }

      const maxUv = Math.max(...this.freqData.map(item => item.uv))
      let lineY = 20
      let tooltipPosX = 0
      let tooltipPosY = 0
      let highestUv = 0
      let highestPv = 0

      // 선 그리기
      let d = ''

      // 먼저 선 그리기 위한 데이터 준비
      this.freqData.forEach((item, index) => {
        const currentUv = item.uv
        let lineX = (this.graphWidth - 94) * (currentUv / maxUv) + 10

        if (index === 0) {
          d += `M${lineX} ${lineY}`
        } else {
          d += ` L${lineX} ${lineY}`
        }

        lineY += 40 // 다음 데이터 포인트의 Y 위치 업데이트
      })

      const path = document.createElementNS(ns, 'path')
      path.setAttribute('d', d)
      path.setAttribute('stroke', this.isRange ? '#A587F8' : '#64B4C6')
      path.setAttribute('stroke-width', 2)
      path.setAttribute('fill', 'none')
      svg.appendChild(path)

      lineY = 20
      this.freqData.forEach((item, index) => {
        const currentUv = item.uv
        const currentPv = this.convertPvToNumber(item.pv)
        let lineX = (this.graphWidth - 94) * (currentUv / maxUv) + 10

        // 첫 번째 데이터 포인트에 대해서만 'M' 명령어 사용
        if (index === 0) {
          d += `M${lineX} ${lineY}`
        } else {
          d += ` L${lineX} ${lineY}`
        }

        // 원 그리기
        const circle = document.createElementNS(ns, 'circle')
        circle.setAttribute('cx', lineX)
        circle.setAttribute('cy', lineY)
        circle.setAttribute('r', 4)
        circle.setAttribute('fill', 'white')
        circle.setAttribute('stroke', this.isRange ? '#A587F8' : '#64B4C6')
        if (this.bigFanIndex === index) {
          circle.setAttribute('stroke', '#EC0047')
          circle.setAttribute('stroke-width', 2)
        }
        svg.appendChild(circle)

        // UV 텍스트 그리기
        const uvText = document.createElementNS(ns, 'text')
        uvText.setAttribute('x', lineX + 10)
        uvText.setAttribute('y', lineY + 4)
        uvText.setAttribute('fill', 'black')
        uvText.setAttribute('font-size', '12')
        uvText.setAttribute('font-weight', '500')
        uvText.setAttribute('font-family', 'Pretendard Variable')
        uvText.textContent = thousand(currentUv)

        if (this.bigFanIndex === index) {
          uvText.setAttribute('fill', '#EC0047')
          uvText.setAttribute('font-weight', '600')
          tooltipPosY = lineY - 74
        }
        svg.appendChild(uvText)

        // 툴팁 위치 결정
        if (currentUv > highestUv || (currentUv === highestUv && currentPv > highestPv)) {
          highestUv = currentUv
          highestPv = currentPv
        }

        lineY += 40
      })

      this.maxCircleY = `${tooltipPosY}px`
    },
    convertPvToNumber (pv) {
      if (pv === 'over') {
        return this.option === 'session' ? parseInt(31) : parseInt(51)// '51+'의 경우 51로 변환
      } else if (pv.includes('-')) {
        return parseInt(pv.split('-')[0], 10) // 범위의 최소값을 사용 ('11-50'의 경우 11로 변환)
      } else {
        return parseInt(pv, 10) // 그 외 숫자 문자열은 정수로 변환
      }
    },
    onSelectClick (e, item = null, index) {
      if (this.isRange) return
      let pv = null

      const baseY = this.$refs.rangeRef.getBoundingClientRect().y
      const startY = e.clientY
      const rangeStartIdx = Math.floor((startY - baseY) / FREQUENCY_HEIGHT)

      this.rangeTopPosition = rangeStartIdx * FREQUENCY_HEIGHT + 'px'
      if (rangeStartIdx * FREQUENCY_HEIGHT > 276) {
        this.rangeTopPosition = '276px'
      } else {
        this.rangeTopPosition = rangeStartIdx * FREQUENCY_HEIGHT + 'px'
      }

      this.selectHeight = FREQUENCY_HEIGHT
      this.isClicked = true
      if (item) {
        if (item.pv.includes('-')) {
          pv = item.pv.split('-').map(Number)
          this.freqTotalPv = item.totalPv
        } else if (item.pv === 'over') {
          pv = [-1]
          this.freqTotalPv = item.totalPv
        } else {
          pv = [Number(item.pv)]
          this.freqTotalPv = item.totalPv
        }
      }
      this.selectedIndex = index
      this.setFreqSelect({
        selectHeight: this.selectHeight,
        rangeTopPosition: this.rangeTopPosition,
        isClicked: this.isClicked
      })

      this.$emit('onFreqOption', this.option)
      this.$emit('getFreqTotalPv', this.freqTotalPv)
      this.$emit('onFreqSelected', pv)
    },
    sameSelect () {
      if (this.isRange) return
      if (this.isClicked) {
        this.selectHeight = null
        this.rangeTopPosition = null
        this.isClicked = false
        this.$store.commit('clearFreqSelect')
        this.$emit('getFreqTotalPv', null)
        this.$emit('onFreqSelected', null)
      }
    },
    onRangeCheck () {
      if (this.isRange) {
        this.isClicked = false
        this.isRange = false
        this.selectHeight = null
        this.rangeTopPosition = null
        this.$store.commit('clearFreqSelect')
        this.$store.commit('clearFreqRangeSelect')
        this.setFreqRange(this.isRange)
        this.$emit('getFreqTotalPv', null)
        this.$emit('onFreqSelected', null)
      } else {
        this.isRange = true
        this.isClicked = false
        this.selectHeight = null
        this.rangeTopPosition = null
        this.isClicked = false
        this.$store.commit('clearFreqRangeSelect')
        this.$store.commit('clearFreqSelect')
        this.setFreqRange(this.isRange)
        this.$emit('getFreqTotalPv', null)
        this.$emit('onFreqSelected', null)
      }
    },
    startDrag (e) {
      if (this.isRange) {
        this.baseY = this.$refs.rangeRef.getBoundingClientRect().y
        this.startY = this.isMobile ? e.touches[0].clientY : e.clientY
        this.mobileY = this.isMobile && e.touches[0].pageY
        this.rangeStartIdx = Math.floor((this.startY - this.baseY) / FREQUENCY_HEIGHT)
        this.rangeTopPosition = this.rangeStartIdx * FREQUENCY_HEIGHT + 'px'
        this.dragging = true
        this.isRangeSelect = true

        if (this.isMobile) {
          window.addEventListener('touchmove', this.drag, { passive: false })
          window.addEventListener('touchend', this.stopDrag, { passive: false })
          this.$emit('onMobileAndDragging', this.isMobile, this.dragging)
        } else {
          window.addEventListener('mousemove', this.drag)
          window.addEventListener('mouseup', this.stopDrag)
        }
      }
      if (this.isRange) {
        this.baseY = this.$refs.rangeRef.getBoundingClientRect().y
        this.startY = this.isMobile ? e.touches[0].clientY : e.clientY
        this.mobileY = this.isMobile && e.touches[0].pageY
        this.rangeStartIdx = Math.floor((this.startY - this.baseY) / FREQUENCY_HEIGHT)
        this.rangeTopPosition = this.rangeStartIdx * FREQUENCY_HEIGHT + 'px'
        this.dragging = true
        this.isRangeSelect = true

        if (this.isMobile) {
          window.addEventListener('touchmove', this.drag, { passive: false })
          window.addEventListener('touchend', this.stopDrag, { passive: false })
          this.$emit('onMobileAndDragging', this.isMobile, this.dragging)
        } else {
          window.addEventListener('mousemove', this.drag)
          window.addEventListener('mouseup', this.stopDrag)
        }
      }
    },
    drag (e) {
      if (!this.dragging) return

      const dragY = this.isMobile ? e.touches[0].clientY : e.clientY
      const upMoveY = this.startY - dragY
      const downMoveY = dragY - this.startY
      const index = Math.floor(((dragY + 3) - this.baseY) / FREQUENCY_HEIGHT)

      if (this.isMobile) {
        const moveY = e.touches[0].pageY
        const diffY = moveY - this.mobileY

        this.$refs.frequencyRef.style.touchAction = 'none'
        e.preventDefault()

        if (window.scrollY === 0 && diffY > 0) {
          e.preventDefault()
        }
      }

      if (dragY < this.startY) {
        if (this.rangeStartIdx === 0) {
          return
        }
        if (index !== this.rangeStartIdx) {
          if (index < 0) {
            return
          }
          this.selectHeight = Math.max(FREQUENCY_HEIGHT, FREQUENCY_HEIGHT * (this.rangeStartIdx - (index - 1)))
        } else {
          this.selectHeight = FREQUENCY_HEIGHT
        }
        if (this.selectHeight) {
          this.rangeBottomPosition = (6 - (this.rangeStartIdx + 1)) * FREQUENCY_HEIGHT + 'px'
          this.rangeTopPosition = 'auto'
        }
      } else {
        if (this.rangeStartIdx === 7) {
          return
        }
        if (index !== this.rangeStartIdx) {
          if (index > 7) {
            return
          } else {
            this.selectHeight = Math.max(FREQUENCY_HEIGHT, FREQUENCY_HEIGHT * (index - (this.rangeStartIdx - 1)))
          }
        } else {
          this.selectHeight = FREQUENCY_HEIGHT
        }
        if (this.selectHeight > FREQUENCY_HEIGHT) {
          this.rangeTopPosition = this.rangeStartIdx * FREQUENCY_HEIGHT + 'px'
          this.rangeBottomPosition = 'auto'
        }
      }
    },
    stopDrag (e) {
      this.dragging = false
      const endY = this.isMobile ? e.changedTouches[0].clientY : e.clientY

      this.rangeEndIdx = Math.floor((endY - this.baseY) / FREQUENCY_HEIGHT)

      if (this.rangeStartIdx === this.rangeEndIdx || this.rangeEndIdx > 6 || this.rangeEndIdx < 0) {
        this.isRangeSelect = false
        this.rangeEndIdx = null
        this.rangeStartIdx = null
        this.$store.commit('clearFreqSelect')
        this.$store.commit('clearFreqRangeSelect')
        this.$emit('getFreqTotalPv', null)
        this.$emit('onFreqSelected', null, null, null)
        this.$emit('onMobileAndDragging', this.isMobile, this.dragging)
        return
      } else {
        if ((this.option === 'session' && FREQUENCY_SESSION_RANGE[this.rangeStartIdx] && FREQUENCY_SESSION_RANGE[this.rangeEndIdx]) ||
        this.option === 'pv' && FREQUENCY_PV_RANGE[this.rangeStartIdx] && FREQUENCY_PV_RANGE[this.rangeEndIdx]) {
          const rangeSelect = this.option === 'session' ? [FREQUENCY_SESSION_RANGE[this.rangeStartIdx], FREQUENCY_SESSION_RANGE[this.rangeEndIdx]] : [FREQUENCY_PV_RANGE[this.rangeStartIdx], FREQUENCY_PV_RANGE[this.rangeEndIdx]]
          const result = rangeSelect.flat()
          let slicePv
          if (this.rangeStartIdx > this.rangeEndIdx) {
            slicePv = this.freqData.slice(this.rangeEndIdx, this.rangeStartIdx + 1)
            this.freqTotalPv = slicePv.reduce((acc, cur) => {
              return acc + cur.totalPv
            }, 0)
          } else {
            slicePv = this.freqData.slice(this.rangeStartIdx, this.rangeEndIdx + 1)
            this.freqTotalPv = slicePv.reduce((acc, cur) => {
              return acc + cur.totalPv
            }, 0)
          }

          this.$emit('onFreqOption', this.option)
          this.$emit('getFreqTotalPv', this.freqTotalPv)
          this.$emit('onFreqSelected', result)
          this.setFreqRangeSelect({
            isRange: this.isRange,
            selectHeight: this.selectHeight,
            rangeTopPosition: this.rangeTopPosition,
            rangeBottomPosition: this.rangeBottomPosition,
            rangeStartIdx: this.rangeStartIdx,
            isRangeSelect: this.isRangeSelect
          })
        }
      }

      if (this.isMobile) {
        window.removeEventListener('touchmove', this.drag)
        window.removeEventListener('touchend', this.stopDrag)
        this.$emit('onMobileAndDragging', this.isMobile, this.dragging)
      } else {
        window.removeEventListener('mousemove', this.drag)
        window.removeEventListener('mouseup', this.stopDrag)
      }
    },
    uvOverHandler (index) {
      this.$set(this.hoverState, index, true)
      this.uvHoverIndex = index
    },
    uvLeaveHandler (index) {
      this.$set(this.hoverState, index, false)
      this.uvHoverIndex = null
    },
    selectedOption () {
      this.option = this.option === 'session' ? 'pv' : 'session'
      this.loadFreqData(this.option)
      this.isClicked = false
      this.selectHeight = null
      this.rangeTopPosition = null
      this.isClicked = false
      this.$store.commit('clearFreqRangeSelect')
      this.$store.commit('clearFreqSelect')
      this.$emit('onFreqSelected', null)
      this.$emit('getFreqTotalPv', null)
    }
  },
  beforeDestroy () {
    window.removeEventListener('mousemove', this.drag)
    window.removeEventListener('mouseup', this.stopDrag)
    window.removeEventListener('resize', () => {
      this.drawLineGraph()
    })
  }
}
</script>

<style lang="scss">
.reporting__frequency {
  min-height: 412px;
  height: 100%;
  border-radius: 14px;
  background: #FFF;
  box-shadow: 0px 23px 15px -12px rgba(0, 0, 0, 0.08), 0px 0px 0px 1px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  position: relative;
  margin-bottom: 50px;

  .icon-binding {
    width: 6px;
    height: 38px;
    background: url(../../assets/img/icon_line_connected.svg) no-repeat center;
    position: absolute;
    left: 50%;
    bottom: 97%;
    z-index: 99;
    transform: translateX(-50%);
  }

  .frequency_wrapper {
    padding: 25px 25px 20px;

    .frequency_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 15px;

      .frequency_title {
        color: #000;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        align-items: center;

        > .icon.icon--beta-small {
          background-position: center center;
          background-repeat: no-repeat;
          background-size: contain;
          margin-right: 8px;
        }
      }

      .option-wrap {
        display: flex;
        align-items: center;

        .option {
          padding: 11px 12px;
          text-align: center;
          font-size: 13px;
          font-weight: 500;
          line-height: 13px; /* 100% */
          box-sizing: border-box;
          cursor: pointer;
          box-shadow: inset 0 0 0 1px #e0e0e0;
          border-radius: 7px;
          transition: box-shadow 0.3s ease, color 0.3s ease, background-color 0.3s ease, -webkit-box-shadow 0.3s ease;

          &:first-child {
            background-color: #fff;
            border-right: none;
            border-radius: 7px 0  0 7px;

            &.session {
              z-index: 2;
              border: none;
              background: #EC0047;
              color: #fff;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.35) inset;
            }
          }

          &:last-child {
            width: 60px;
            border-radius: 0 7px 7px 0;
            background: #FFF;
            margin-left: -1px;

            &.pv {
              border: none;
              color: #fff;
              background: #EC0047;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.35) inset;
            }
          }
        }

      }
    }

    .frequency_text_wrap {
      display: flex;
      flex-direction: column;
      gap: 21px;
      margin-bottom: 15px;

      .frequency_average {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 15px;

        .text {
          color: #EC0047;
          font-size: 12px;
          font-weight: 400;
          line-height: 12px; /* 100% */
        }

        .checkbox_wrap {
          position: relative;
          cursor: pointer;

          .icon {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }

          .text {
            font-size: 13px;
            color: #444;
            margin-left: 25px;
          }
        }
      }
    }

    .frequency_graph_container {
      display: flex;
      flex-direction: column;
      gap: 10px;
      min-width: 320px;
      height: 100%;
      width: 100%;

      .frequency_guide {
        display: flex;
        justify-content: space-around;
        color: #444;
        text-align: center;
        padding-left: 5px;

        div {
          font-size: 12px;
          font-weight: 400;
          line-height: 12px; /* 100% */
          display: flex;
          gap: 5px;
          align-items: center;

          &:first-child {
            width: 75px;
            text-align: left;
          }

          &:last-child {
            width: calc(100% - 50px);
            justify-content: center;
          }
        }
      }

      .frequency_graph_wrap {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 320px;
        height: 240px;

        .graph_y {
          min-width: 74px;
          max-width: 64px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          gap: 1px;

          .text_wrap {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #EBEBEB;

            &:last-child {
              border-bottom: 1px solid transparent;
            }

            .text_y {
              background: #fff;
              color: #444;
              font-size: 13px;
              font-weight: 500;
              line-height: 120%; /* 15.6px */
              text-align: left;
              box-sizing: border-box;
              user-select:none;
              padding-left: 2px;

              &.maxVisits {
                width: 50%;
                padding-bottom: 8px;
              }

              .max {
                font-size: 11px;
                font-weight: 500;
                line-height: 13.2px;
                text-align: center;
              }
            }

            &.big {
              .text_y {
                color: $brandColor;
              }

              .big-fan {
                @include flexXYcenter;
                width: 20px;
                height: 20px;
                border: 1px solid #ED1C5B;
                border-radius: 50%;
                margin-right: 5px;
                box-shadow: 0px 5px 6px rgba(0, 0, 0, 0.16);
              }
            }

          }
        }

        .graph {
          min-width: 246px;
          width: 100%;
          height: 100%;
          position: relative;

          .bg-container {
            z-index: 8;
            position: absolute;
            width: 100%;
            height: 100%;

            .select-bg {
              position: absolute;
              left: -2px;
              z-index: 9;
              width: 100%;
              height: 100%;
              max-height: 320px;
              transition: all .2s;
              cursor: pointer;
              border-radius: 6px;
              margin-top: -2px;

              &.select {
                border-radius: 6px;
                border: 2px solid #0074FF;
                background: rgba(0, 116, 255, 0.25);
                box-shadow: 0px 1px 1px 0px #FFF inset, 0px 10px 12px -2px rgba(0, 0, 0, 0.25);
              }

              &.rangeSelect {
                border-radius: 6px;
                border: 2px solid #6744B7;
                box-shadow: 0px 10px 12px -2px rgba(0, 0, 0, 0.25), 0px 1px 1px 0px #FFF inset;
                background: rgba(137, 83, 255, 0.25);

                > .dot-line {
                  position: absolute;
                  top: 0;
                  left: 50%;
                  transform: translateX(-50%);
                  display: inline-block;
                  height: 99%;
                  width: 1px;
                  background-image: linear-gradient(to bottom, transparent 50%, #fff 50%);
                  background-size: 1px 5px;
                  &::before {
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    height: 8px;
                    width: 8px;
                    background-image: url("../../assets/img/Triangle.svg");
                    background-repeat: no-repeat;
                    background-position: center center;
                  }
                  &::after {
                    content: '';
                    position: absolute;
                    bottom: -3px;
                    right: 50%;
                    height: 8px;
                    width: 8px;
                    background-image: url("../../assets/img/Triangle.svg");
                    background-repeat: no-repeat;
                    background-position: center center;
                    transform: rotate(180deg) translateX(-50%);
                  }
                }

                &:hover {
                  background: rgba(137, 83, 255, 0.25);
                }
              }

              .insight {
                right: -15px;
              }
            }

            .bg-wrap {
              width: 100%;
              height: 39px;
              background: rgba(0, 0, 0, 0.08);
              transition: all .2s;
              cursor: pointer;
              border-bottom: 1px solid #fff;
              display: flex;
              justify-content: flex-end;
              align-items: center;
              position: relative;

              &:first-child {
                border-top-left-radius: 6px;
                border-top-right-radius: 6px;
              }

              &:last-child {
                border-bottom-left-radius: 6px;
                border-bottom-right-radius: 6px;
                border-bottom: none;
              }

              &.big {
                background: rgba(232, 0, 0, 0.08);
              }

              .uv {
                width: 94px;
                height: 100%;
                color: #2F2F2F;
                font-size: 12px;
                font-weight: 400;
                background: none;
                margin-right: 10px;
                user-select:none;
                line-height: 40px;
                position: absolute;
                left: 10%;

                &.over {
                  width: 50px;
                  overflow: hidden;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                }

              }
              .uv-tooltip {
                right: 20px;
                bottom: 100%;
              }

              &:hover {
                background: rgba(0, 0, 0, 0.048);

                &.big {
                  background: rgba(232, 0, 0, 0.048);
                }
              }

              &.range {
                background: rgba(165, 135, 248, 0.20);

                &.big {
                  background: rgba(243, 4, 250, 0.15);

                  &:hover {
                    background: rgba(243, 4, 250, 0.1);
                  }
                }

                &:hover {
                  background: rgba(165, 135, 248, 0.12);
                }
              }
            }
          }

          .insight {
            @include flexXcenter;
            position: absolute;
            max-width: 200px;
            width: 100%;
            color: #444;
            padding: 16px 20px;
            right: -15px;
            line-height: 120%;
            background-color: #fff;
            border-radius: 8px;
            box-sizing: border-box;
            z-index: 9;

            >.text {
              text-align: left;
              color: #444;
              font-feature-settings: 'liga' off, 'clig' off;
              font-size: 12px;
              font-weight: 400;
              line-height: 144%; /* 18.72px */
              word-break: keep-all;
              white-space: normal;
            }

          }

          svg {
            position: absolute;

            &.notHover {
              z-index: 8;
            }
          }
          .tooltip-click {
            position: absolute;
            z-index: 9;
          }
        }
      }
    }
  }

  .frequency_big_fan_container {
    padding: 25px;
    border-top: 1px solid #EBEBEB;

    .big-fan-zone {
      @include flexYcenter;
      gap: 6px;
      color: #EC0047;
      font-size: 13px;
      font-weight: 500;
      line-height: 120%; /* 15.6px */
      margin-bottom: 6px;

      .icon {
        width: 16px;
        height: 16px;
        border: 1px solid #ED1C5B;
        border-radius: 50%;
        background-position: center;
      }
    }

    .big-fan-desc {
      color: #444;
      font-size: 12px;
      font-weight: 400;
      line-height: 150%; /* 18px */

      &.ja {
        word-break: keep-all;
        white-space: normal;
      }
    }
  }

  .none-pv-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 25px 25px 20px;

    .frequency_header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 15px;
      .frequency_title {
        color: #000;
        font-size: 16px;
        font-weight: 500;
        display: flex;
        align-items: center;
      }
      .option-wrap {
        display: flex;
        align-items: center;

        .option {
          padding: 11px 12px;
          text-align: center;
          font-size: 13px;
          font-weight: 500;
          line-height: 13px; /* 100% */
          box-sizing: border-box;
          cursor: pointer;
          box-shadow: inset 0 0 0 1px #e0e0e0;
          border-radius: 7px;
          transition: box-shadow 0.3s ease, color 0.3s ease, background-color 0.3s ease, -webkit-box-shadow 0.3s ease;

          &:first-child {
            background-color: #fff;
            border-right: none;
            border-radius: 7px 0  0 7px;

            &.session {
              z-index: 2;
              border: none;
              background: #EC0047;
              color: #fff;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.35) inset;
            }
          }

          &:last-child {
            width: 60px;
            border-radius: 0 7px 7px 0;
            background: #FFF;
            margin-left: -1px;

            &.pv {
              border: none;
              color: #fff;
              background: #EC0047;
              box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.35) inset;
            }
          }
        }

      }
    }

    .none-pv-text {
      height: 100%;
      text-align: center;
      color: #2f2f2f;
      font-size: 13px;
      font-weight: 400;
      padding: 0 88px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}

</style>
